import Marquee from "react-fast-marquee";

const WORDS = [
  "Interventional Cardiology",
  "Endovascular Aneurysm Repair",
  "Carotid Artery Stenting",
  "Arrhythmia Management",
  "Heart Failure Care",
  "U.N. Mehta Institute",
  "Academic Excellence",
  "Preventive Cardiology",
];

export function EditorialMarquee({ dark = false }) {
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative border-y border-white/10 py-8 ${
        dark ? "bg-ink" : "bg-ink2"
      }`}
    >
      <Marquee speed={45} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-serif text-4xl md:text-6xl font-light text-white/25">
              {w}
            </span>
            <span className="text-crimson text-2xl md:text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
